import { createRouter, createWebHistory } from 'vue-router';
import home from '@/component/home/home.vue';
import courseInfo from '@/component/course-info/course-info.vue';
import play from '@/component/course-info/play/play.vue';
import personal from '@/component/personal/personal.vue';
import admin from '@/component/admin/admin.vue';
import payment from '@/component/course-info/payment/payment.vue';
import payfinish from '@/component/course-info/payment/pay-finish/pay-finish.vue';

const routes = [
  { path: '/', redirect: 'home' },
  { path: '/home', name: 'home', component: home },
  { path: '/home/:type', name: 'homeType', component: home },
  // 数字课程信息
  { path: '/course-info/:id', name: 'course', component: courseInfo },
  // 支付
  { path: '/payment/:id', name: 'payment', component: payment },
  // 支付完成页
  { path: '/payfinish/:id', name: 'payfinish', component: payfinish },
  // 视频播放
  { path: '/play/:id', name: 'play', component: play },
  // 个人中心
  { path: '/personal', name: 'personal', component: personal },
  // 管理员
  { path: '/admin', name: 'admin', component: admin },
]
const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
